import React from "react";
import './Benefits.css'
import Benefit from './../images/benefits.png'
const Benefits = () =>{
return(
    <div>
        <div className="benefits text-center" id="benefits">
            <div className="container">
            <h6>Key Benefits</h6>
          <h1>Advanced DIGITAL Platform for Vendor Management</h1>
                <div className="row">
               
                    <div className="col-md-4">
                        <ul>
                            <li>Automate manual task</li>
                            <li>Ensure Quality compliance</li>
                            <li>Decrease in spend cost</li>
                            <li>Improve communication transparency</li>
                            <li>Security & Admin control</li>
                            <li>Complete control over procurement</li>
                        </ul>
                    </div>
                    <div className="col-md-4">
                        <img src={Benefit} alt="benefits"/>
                    </div>
                    <div className="col-md-4">
                    <ul>
                            <li>Easy management of approvals</li>
                            <li>Vendor Self Service Facility</li>
                            <li>Reduced Cycle times</li>
                            <li>Vendor retention & growth</li>
                            <li>Increased ROI – Procurement</li>
                            <li>Advanced reporting & analytics history</li>
                            
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
)
}

export default Benefits;